/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ItemService from "../../../services/inventory_appCommonService";

const initialState = {
  productionOrder: {
    data: [],
    status: true,
    proNr: "",
    workflow: [],
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
  warehouse: {
    data: [],
    status: true,
    warehouseNr: "",
    workflow: [],
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
  whOrder: {
    data: [],
    status: true,
    whOrderNr: "",
    workflow: [],
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
  stock: {
    data: [],
    status: true,
    stockNr: "",
    workflow: [],
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
};

export const inventorySlice = createSlice({
  name: "inventory",
  initialState,
  reducers: {
    addProNr(state, action) {
      state.productionOrder.proNr = action.payload;
    },
    addWarehouse(state, action) {
      state.warehouse.warehouseNr = action.payload;
    },
    addOrder(state, action) {
      state.whOrder.whOrderNr = action.payload;
    },
    addStock(state, action) {
      state.stock.stockNr = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(getProductionOrderList.pending, (state, action) => {
        state.productionOrder.status = true;
      })
      .addCase(getProductionOrderList.fulfilled, (state, action) => {
        state.productionOrder.data = action.payload.data;
        state.productionOrder.pagination.page = action.payload.page;
        state.productionOrder.pagination.per_page = action.payload.per_page;
        state.productionOrder.pagination.total = action.payload.total;
        state.productionOrder.status = false;
      })
      .addCase(getWarehouseList.pending, (state, action) => {
        state.warehouse.status = true;
      })
      .addCase(getWarehouseList.fulfilled, (state, action) => {
        state.warehouse.data = action.payload.data;
        state.warehouse.pagination.page = action.payload.page;
        state.warehouse.pagination.per_page = action.payload.per_page;
        state.warehouse.pagination.total = action.payload.total;
        state.warehouse.status = false;
      })
      .addCase(getWhOrderList.pending, (state, action) => {
        state.whOrder.status = true;
      })
      .addCase(getWhOrderList.fulfilled, (state, action) => {
        state.whOrder.data = action.payload.data;
        state.whOrder.pagination.page = action.payload.page;
        state.whOrder.pagination.per_page = action.payload.per_page;
        state.whOrder.pagination.total = action.payload.total;
        state.whOrder.status = false;
      })
      .addCase(getStockList.pending, (state, action) => {
        state.stock.status = true;
      })
      .addCase(getStockList.fulfilled, (state, action) => {
        state.stock.data = action.payload.data;
        state.stock.pagination.page = action.payload.page;
        state.stock.pagination.per_page = action.payload.per_page;
        state.stock.pagination.total = action.payload.total;
        state.stock.status = false;
      });
  },
});

export const { addProNr, addWarehouse, addStock, addOrder } =
  inventorySlice.actions;

export const getProductionOrderList = createAsyncThunk(
  "getProductionOrderList",
  async (param) => {
    console.log(">> loaded getProductionOrderList");
    const res = await ItemService.generateCustomerQuery(param);
    return res;
  }
);

export const getWarehouseList = createAsyncThunk(
  "getWarehouseList",
  async (param) => {
    console.log(">> loaded getWarehouseList");
    const res = await ItemService.generateCustomerQuery(param);
    return res;
  }
);

export const getWhOrderList = createAsyncThunk(
  "getWhOrderList",
  async (param) => {
    console.log(">> loaded getOrderList");
    const res = await ItemService.generateCustomerQuery(param);
    return res;
  }
);
export const getStockList = createAsyncThunk("getStockList", async (param) => {
  console.log(">> loaded getStockList");
  const res = await ItemService.generateCustomerQuery(param);
  return res;
});
export default inventorySlice.reducer;
